import { motion } from 'framer-motion';

export default function SectionDivider({ number }) {
  return (
    <div className="flex flex-col items-center justify-center py-12 sm:py-20 relative z-10">
      {number && (
        <span className="text-[14px] sm:text-[16px] font-semibold text-white/25 font-mono tracking-[0.15em] mb-4">
          {number}
        </span>
      )}
      <div className="w-[120px] sm:w-[160px] h-[3px] bg-white/[0.12] rounded-full relative overflow-hidden">
        <motion.div 
          className="absolute top-0 w-[50px] h-full rounded-full"
          style={{ background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.6), transparent)' }}
          animate={{ x: [-50, 160] }}
          transition={{ duration: 2.5, repeat: Infinity, ease: 'easeInOut' }}
        />
      </div>
    </div>
  );
}
